module.exports = __webpack_public_path__ + "media/images/icons/material/earth-f2fee57a7f55047a4bdb8f2d5b987b2e.svg";